import { render, staticRenderFns } from "./disease_factors.vue?vue&type=template&id=8677d2da&scoped=true"
import script from "./disease_factors.vue?vue&type=script&lang=js"
export * from "./disease_factors.vue?vue&type=script&lang=js"
import style0 from "./disease_factors.vue?vue&type=style&index=0&id=8677d2da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8677d2da",
  null
  
)

export default component.exports